import { GzApplicationControlRulesFormWebComponent } from './component/GzApplicationControlRulesFormWebComponent';

export { GzApplicationControlRulesFormWebComponent };
